(function() {
  'use strict';

  angular
    .module('in-out-rm')
    .controller('newmentorController', newmentorController);

  newmentorController.$inject = ['$scope','sidetopHttp','$http','$timeout','getMentorshipMentorId','newmentorInitData','$state','$window','$rootScope','$stateParams', 'features','$filter'];
  function newmentorController($scope,sidetopHttp,$http,$timeout,getMentorshipMentorId,newmentorInitData,$state,$window,$rootScope,$stateParams,features,$filter) {
    
    //variables
    $scope.s3base = s3base;
    $scope.myUid = $rootScope.app_data.uid; //rootscope
    $scope.myCid = $rootScope.app_data.cid; //rootscope
    $scope.bcCreationData = '';

    $scope.finalSectors = [];
    $scope.mentorId = 0;  //give mentor-id or zero
    $scope.mentorInfo = null;
    $scope.mentorMessage = '';
    $scope.mentorPreferences = [];
    $scope.user_sector = null;
    $scope.info={};

    $scope.changeAvailability = false;

    //function bindings
    $scope.beMentor = beMentor;
    $scope.isMentor= isMentor;
    $scope.getMentorInfo = getMentorInfo;
    $scope.changeAvailabilityFun = changeAvailabilityFun;
    $scope.changeMessageFun = changeMessageFun;
    $scope.removeSectors = removeSectors;
    $scope.addSectors = addSectors;
    $scope.tickPreference = tickPreference; 
    $scope.removeAsMentor = removeAsMentor;
    

    //variables for front-end
    $scope.mentorFormSubmit = false;
    $scope.addedSectors = [];
    $scope.removedSectors = [];
    $scope.userSectors = [];
    $scope.brSet = false;
    

    //functions for front-end
    $scope.mentorFormSubmitFun = mentorFormSubmitFun;
    $scope.adjustSectors = adjustSectors;


    //actiivate
    activate();

    function activate() {
      fetchAllSectors();
      set_extra_params();

      //data fetch failure
      if(newmentorInitData.data.success != 1){
        try{
          $scope.pageMessage = newmentorInitData.data.data.message;  
          $scope.pageError = newmentorInitData.data.data.error;
        }
        catch(e){}
      }//user is mentor
      else{
        $scope.userSectors = newmentorInitData.data.data.sectors;
        $scope.finalSectors = $scope.userSectors.slice();

        if(Array.isArray($scope.userSectors) && $scope.userSectors.length == 1)
          $scope.user_sector = $scope.userSectors[0]['id'];
      }
      
      $scope.isMobile=mobile_web_tab.isMobile;
      $scope.isMentor();

      console.log('fword',$scope.mentorId);
      if(!$scope.mentorId && chk_restrictions(48,false,true)) {
        return;
      }

      //breadcrumbs
      $scope.bcCreationData = window.location.search;
      $scope.bcCreationData += ("?mentorid=" + encodeURIComponent($scope.mentorId));
      $scope.brSet = true;
      
      console.log($scope.bcCreationData);
      $scope.$on('$destroy', function () {
        //deleteStream();
      });
      $window.onbeforeunload = function(){
        $scope.$destroy();
      };

      $scope.preferences = [
        'Higher Studies',
        'Career Advice',
        'Personal Guidance'
      ];
    }
    
    //functions
    
    function beMentor(message, preferences){
        var data ={
          message: message,
          preferences: preferences
        };
        data.approved = (features.enabled('mentorship.admin_approval.*', false)) ? 0 : 1;
        $scope.calling_api = true;

        return sidetopHttp.postDataCall('./mentorship/mentorship/new_mentor',data,function(response) {
          $scope.calling_api = false;
          if (response.success == 1) {
            if(chk_approvals_return(48)){
              swal({
                          title:"Submitted Successfully",
                          text:"Other "+$filter("asLingo")('56','','lowercase')+" can view it once it is approved by admin",
                          icon: "success",
                          buttons:{
                            confirm: {text: "OK"}
                          }
                        }).then(function(response) {
                          if(response!=null){
                            swal.close();
                            direct_to_profile_completion();
                          }
                        });
            }
            else{
              direct_to_profile_completion();
            }
              // $scope.pageMessage = "Request is sent to admin.";
              // $scope.pageMessage = "Registered successfully as a mentor.";
              // $scope.mentorId = response.data.mentor_id;
              // $scope.getMentorInfo();
              // snackbar_general($scope.pageMessage, 2500);
          }
          else{
              try{
                $scope.pageMessage = response.data.message;
                $scope.pageError = response.data.error;
                snackbar_general("Something went wrong.", 3500);  
              }
              catch(e){

              }
          }
        });
    }

    function direct_to_profile_completion(){
      var allowedFor = {
        'skills': {
          'reason': 'Let people know about your '+$filter('asLingo')('42')
        },
        'photo': {
          'reason': 'Let people recognize you in the Directory.'
        }
      };

      $state.go('inapp.extra_info', {
        fields: 'skills,work,education,photo',
        pref: 'noSocial',
        removeHeader: false,
        extra_params: {
          redirect: "inapp.newmentor",
          allowedFor: allowedFor
        }
      });

    }


    function getMentorInfo(){

        var data ={
          mentor_id: $scope.mentorId
        };

        return sidetopHttp.postDataCall('./mentorship/mentorship/get_mentor',data,function(response) {
          if (response.success == 1) {
              $scope.mentorInfo = response.data.mentor;
              $scope.info.availability = angular.copy($scope.mentorInfo.mentor_available);
              $scope.info.avail = true;
              if($scope.mentorInfo.mentor_approved_status != 2){
                  $scope.mentorMessage = $scope.mentorInfo.mentor_message;
                  if($scope.mentorInfo.mentor_available_for)
                    $scope.mentorPreferences = $scope.mentorInfo.mentor_available_for.split(',');
              }
              var userType='user';
              if($rootScope.app_data.isAdmin)
                userType='admin';
              else
                userType='poster';
              
              $scope.info.approvalStatusData = {
                  'userType': userType,
                  'featureName': 'Mentorship',
                  'approvalStatus':$scope.mentorInfo.state,
                  'approverUui':$scope.mentorInfo.approver_uui,
                  'cas_obj':{'cas_id':$scope.mentorInfo.content_id}
              };
          }
          else{
              try{
                $scope.pageMessage = response.data.message;
                $scope.pageError = response.data.error;  
                snackbar_general("Mentor info could not be loaded", 3500);
              }
              catch(e){

              }
          }
        });
    }


    function isMentor(){
     
     var response = getMentorshipMentorId.data;
      if(response.success != 1){
        if(response.success == -1){
          $scope.mentorId = 0;
          // user is not a mentor
        }
        else{
          try{
            $scope.pageMessage = response.data.message;  
            $scope.pageError = response.data.error;
          }
          catch(e){}
        }
        
      }//user is mentor
      else{
        $scope.mentorId =response.data.mentor.id;
        $scope.getMentorInfo();
      }
        
    }


    function changeAvailabilityFun(){

        var data ={
          mentor_id: $scope.mentorId
        };
        var url = './mentorship/mentorship';
        if($scope.mentorInfo.mentor_available == 1){
          url = url + '/unavail_mentor';
        }
        else{
          url = url + '/avail_mentor';
        }

        return sidetopHttp.postDataCall(url,data,function(response) {
          if (response.success == 1) {
              //successful
              $scope.getMentorInfo();
              snackbar_general("Mentor availability updated successfully.", 3500);
          }
          else{
              try{
                $scope.pageMessage = response.data.message;
                $scope.pageError = response.data.error;  
                snackbar_general("Something went wrong.", 3500);
              }
              catch(e){

              }
          }
        });
    }


    function changeMessageFun(newmessage, preferences){

        var data ={
          mentor_id: $scope.mentorId,
          message: newmessage,
          preferences: preferences,
          available: $scope.info.availability
        };
        var url = './mentorship/mentorship/update_mentor_message';
        $scope.calling_api = true;
        return sidetopHttp.postDataCall(url,data,function(response) {
          $scope.calling_api = false;
          if (response.success == 1) {
              //successful
             
              if($scope.mentorInfo.mentor_approved_status != 2){
                $scope.pageMessage = 'Information updated successfully.';
              }
              else{
                $scope.pageMessage = 'Mentorship request is re-submitted to admin.';
              }
              
              $scope.mentorInfo.mentor_message = newmessage;
              $scope.getMentorInfo();
              snackbar_general($scope.pageMessage, 2500);
          }
          else{
              try{
                $scope.pageMessage = response.data.message;
                $scope.pageError = response.data.error;  
                snackbar_general("Something went wrong.", 3500);
              }
              catch(e){

              }
          }
        });
    }


    function removeSectors(sector){
        
        var data ={
          user_id: $scope.myUid,
          type: 3,
          sector_id: sector,
          is_array: true
        };
        //here type 3 means sector is for user_profile
  
        var url = './sectors/remove_user_sector';

        return sidetopHttp.postDataCall(url,data,function(response) {
          if (response.success == 1) {
              //successful
          }
          else{
              try{
                $scope.pageMessage = response.data.message;
                $scope.pageError = response.data.error;  
              }
              catch(e){

              }
          }
        });
    }


    function addSectors(sector){
        var data ={
          user_id: $scope.myUid,
          type: 3,
          sector_id: sector,
          is_array: true
        };
        //here type 3 means sector is for user_profile
  
        var url = './sectors/add_user_sector';

        return sidetopHttp.postDataCall(url,data,function(response) {
          if (response.success == 1) {
              //successful
          }
          else{
              try{
                $scope.pageMessage = response.data.message;
                $scope.pageError = response.data.error;  
              }
              catch(e){

              }
          }
        });
    }


    function adjustSectors(){
        //we are removing some items from final array but will be added again at the end
        var foundAlready = false;

        for (var u = 0; u < $scope.userSectors.length; u++) {
            foundAlready = false;
            for (var f = $scope.finalSectors.length - 1; f >= 0; f--) {
              
              if($scope.userSectors[u].id == $scope.finalSectors[f].id){
                // no need to change anything
                $scope.finalSectors.splice(f, 1);
                foundAlready = true;
                break;
              }

            }
            if(!foundAlready){// did not found inready list,means this is new entry
              $scope.addedSectors.push($scope.userSectors[u]);
            }
        }
        //now final_array will contain entries that exist before but not now.
        for (var f = $scope.finalSectors.length - 1; f >= 0; f--) {
             $scope.removedSectors.push($scope.finalSectors[f]);
        }

        $scope.finalSectors = $scope.userSectors.slice();

        //empty added and removes array once sent to database
        var addedIds = [];
        for (var i =  $scope.addedSectors.length - 1; i >= 0; i--) {
            addedIds.push($scope.addedSectors[i].id);
        }
        if( $scope.addedSectors.length != 0 ){
            $scope.addSectors(addedIds);  
        }
        
        var removedIds = [];
        for (var i = $scope.removedSectors.length - 1; i >= 0; i--) {
            removedIds.push($scope.removedSectors[i].id);
        }
        if( $scope.removedSectors.length != 0 ){
            $scope.removeSectors(removedIds);
        }

        $scope.addedSectors = [];
        $scope.removedSectors = [];
    }


    function mentorFormSubmitFun(message, preferences, form){
        $scope.mentorFormSubmit = true;
        $timeout(function() {
            // if(form.$invalid || $scope.userSectors.length == 0) return;
            if(form.$invalid || !$scope.user_sector || $scope.mentorPreferences.length == 0) return;
            else{
              $scope.mentorFormSubmit = false;
              saveUserSector();
              if( $scope.mentorId == 0 ){// first-time registration
                $scope.beMentor(message, preferences);
              }
              if( $scope.mentorId != 0){// change message or re-submitting
                $scope.changeMessageFun(message, preferences);
              }
              //add & remove sectors as changes made
              // $scope.adjustSectors();  // not using multiple user-sectors for now
            }
        }, 100);
    }


    function fetchAllSectors(){
      $http({
          url: './jobs/fetch_all_sectors',
          method: 'POST',
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
          }
      }).success(function(all_sec) {
          $scope.all_sec = all_sec;
      });
      as_upgrade(1000);
    }  

    function saveUserSector(){
        $http({
            url: './jobs/add_sectors/3',
            method: 'POST',
            data: {
                sector_id: $scope.user_sector
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    function tickPreference(pref){
      var found = $scope.mentorPreferences.indexOf(pref);
      if(found > -1) $scope.mentorPreferences.splice(found,1);
      else $scope.mentorPreferences.push(pref);
    }

    function set_extra_params(){
      try{
        var params = $stateParams.extra_params;
        if(!params) return;
        console.log(params.mentorPreferences)
        if(Array.isArray(params.mentorPreferences)){
          $scope.mentorPreferences = params.mentorPreferences;
          if($scope.mentorPreferences.length > 0){
            $scope.mentorMessage = "Approach me for " + $scope.mentorPreferences.join(', ');
          }
        }
      }catch(e){}
    }

    function removeAsMentor() {
      var txt = "Are you sure want to remove yourself as a mentor? ";
      txt += ($scope.mentorInfo.state != 1 && $scope.mentorInfo.state != 2) ? "Your existing request to become mentor will be removed from the request list." : "You will be removed from the mentors list.";
      swal({ 
          title: "Remove myself as mentor",
          text: txt,
          buttons: ['No, Cancel', {text: 'Yes, Remove',closeModal:false}]
      }).then(function(isConfirm) {
          if (isConfirm) {
            var data = {
              mentor_id: $scope.mentorId
            };
            $http.post('./mentorship/mentorship/removeAsMentor', data).success(function(res) {
              if (res.success == 1) {
                swal.stopLoading();
                swal.close();
                snackbar_general('Removed as mentor successfully.', 3000);
                $state.go('inapp.mentorship');
              }
            });
          }
      });
    }

  }
}());
